var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUChevronRightB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1B1F27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5397 11.29L10.8797 5.64004C10.7868 5.54631 10.6762 5.47191 10.5543 5.42115C10.4325 5.37038 10.3017 5.34424 10.1697 5.34424C10.0377 5.34424 9.90702 5.37038 9.78516 5.42115C9.6633 5.47191 9.5527 5.54631 9.45974 5.64004C9.27349 5.8274 9.16895 6.08085 9.16895 6.34504C9.16895 6.60922 9.27349 6.86267 9.45974 7.05004L14.4097 12.05L9.45974 17C9.27349 17.1874 9.16895 17.4409 9.16895 17.705C9.16895 17.9692 9.27349 18.2227 9.45974 18.41C9.55235 18.5045 9.6628 18.5797 9.78467 18.6312C9.90655 18.6827 10.0374 18.7095 10.1697 18.71C10.302 18.7095 10.4329 18.6827 10.5548 18.6312C10.6767 18.5797 10.7871 18.5045 10.8797 18.41L16.5397 12.76C16.6412 12.6664 16.7223 12.5527 16.7777 12.4262C16.8331 12.2997 16.8617 12.1631 16.8617 12.025C16.8617 11.8869 16.8331 11.7503 16.7777 11.6238C16.7223 11.4973 16.6412 11.3837 16.5397 11.29Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUChevronRightB);
export default __webpack_public_path__ + "static/media/u_chevron-right-b.e37c97f2.svg";
export { ForwardRef as ReactComponent };